import type { SectionLocale } from '../types'

export const AUTH_LOCALE: SectionLocale = [
  [
    'page_title_sign_in',
    {
      ru: 'Вход в систему',
      en: 'Sign In',
    },
  ],
  [
    'auth_title_welcome_to',
    {
      ru: 'Добро пожаловать в',
      en: 'Welcome to',
    },
  ],
  [
    'auth_title_corp',
    {
      ru: 'Корпоративный портал',
      en: 'Corporate portal',
    },
  ],
  [
    'auth_description',
    {
      ru: 'Чтобы продолжить, войдите в систему с помощью своего аккаунта в AIXPass',
      en: 'To continue, log in with your AIXPass account.',
    },
  ],
  [
    'auth_login',
    {
      ru: 'Войти через AIXPass',
      en: 'Login via AIXPass',
    },
  ],
  [
    'auth_no_access_title',
    {
      ru: 'Ошибка доступа',
      en: 'Access denied',
    },
  ],
  [
    'auth_no_access_description',
    {
      ru: 'Отсутствует доступ к системе. Обратитесь к вашему администратору для предоставления доступа.',
      en: 'Access to the system is denied. Please contact your administrator to obtain access.',
    },
  ],
  [
    'auth_back',
    {
      ru: 'Назад',
      en: 'Back',
    },
  ],
  [
    'auth_privacy_policy',
    {
      ru: 'Политика конфиденциальности',
      en: 'Privacy Policy',
    },
  ],
]
